if (!customElements.get('vs-tabs')) {
  customElements.define(
    'vs-tabs',
    class VsTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
      }

      select(index, focus = false) {
        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
          tab.setAttribute('aria-selected', selected);
          tab.tabIndex = selected ? 0 : -1;
          if (panel) panel.hidden = !selected;
        });
        if (focus) this.tabs[index].focus();
      }

      onKeydown(event, index) {
        const last = this.tabs.length - 1;
        let next = null;
        if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
        if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = last;
        if (next === null) return;
        event.preventDefault();
        this.select(next, true);
      }
    }
  );
}

if (!customElements.get('vs-sticky-atc')) {
  customElements.define(
    'vs-sticky-atc',
    class VsStickyAtc extends HTMLElement {
      connectedCallback() {
        if (this.parentElement !== document.body) {
          document.body
            .querySelectorAll(`:scope > vs-sticky-atc[data-section-id="${this.dataset.sectionId}"]`)
            .forEach((el) => el !== this && el.remove());
          this.moving = true;
          document.body.appendChild(this);
          return;
        }
        this.moving = false;
        if (this.ready) return;
        this.ready = true;
        this.sectionId = this.dataset.sectionId;
        this.button = this.querySelector('[data-sticky-button]');
        this.label = this.querySelector('[data-sticky-label]');
        this.price = this.querySelector('[data-sticky-price]');
        this.labels = {
          add: this.querySelector('[data-label-add]')?.innerHTML.trim(),
          soldout: this.querySelector('[data-label-soldout]')?.innerHTML.trim(),
          unavailable: this.querySelector('[data-label-unavailable]')?.innerHTML.trim(),
        };

        document.body.classList.add('vs-has-sticky-atc');
        this.observeMainButton();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
        }
      }

      disconnectedCallback() {
        if (this.moving) return;
        this.ready = false;
        if (this.unsubscribe) this.unsubscribe();
        if (this.observer) this.observer.disconnect();
        document.body.classList.remove('vs-has-sticky-atc');
      }

      observeMainButton() {
        const form = document.getElementById(this.dataset.formId);
        const target = form ? form.closest('.product-form') || form : null;
        if (!target || !('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }
        this.observer = new IntersectionObserver(
          ([entry]) => {
            const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.classList.toggle('is-visible', passed);
          },
          { threshold: 0 }
        );
        this.observer.observe(target);
      }

      onVariantChange(event) {
        if (!event || !event.data || event.data.sectionId !== this.sectionId) return;
        const variant = event.data.variant;
        const html = event.data.html;

        if (html && this.price) {
          const source = html.getElementById(`price-${this.sectionId}`);
          if (source) {
            const onSale = source.querySelector('.price--on-sale');
            const current = onSale
              ? source.querySelector('.price__sale .price-item--sale')
              : source.querySelector('.price__regular .price-item--regular');
            const compare = onSale ? source.querySelector('.price__sale s.price-item--regular') : null;
            if (current) {
              this.price.textContent = current.textContent.trim();
              if (compare) {
                const strike = document.createElement('s');
                strike.textContent = compare.textContent.trim();
                this.price.append(' ', strike);
              }
            }
          }
        }

        if (!variant) {
          this.setButton(false, this.labels.unavailable);
        } else if (!variant.available) {
          this.setButton(false, this.labels.soldout);
        } else {
          this.setButton(true, this.labels.add);
        }
      }

      setButton(enabled, text) {
        if (!this.button) return;
        this.button.disabled = !enabled;
        if (this.label && text) this.label.textContent = text;
      }
    }
  );
}
